function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import qt from "./auth-manager.js";
import s from "../common/base-provider.js";
import ro from "../util/browser-detector.js";
import Ot from "./device-manager.js";
import DeviceProperties from "../Core/device-properties.js";
import { isArray as w, keys as y, validateValueIsFromEnum as ta, values as Rt } from "../util/code-utils.js";
import Pt from "./network-manager.js";
import Lt from "../request-controller.js";
import Dt from "./server-config-manager.js";
import Mt from "./session-manager.js";
import ne, { STORAGE_KEYS as t } from "./storage-manager.js";
import Wt from "./storage-manager-factory.js";
import u from "./subscription-manager.js";
import { TriggersProviderFactory as ot } from "../triggers/triggers-provider-factory.js";
import kt from "../User/user-manager.js";
import { User } from "../User/index.js";
import { parseQueryStringKeyValues as ll } from "../util/url-utils.js";
import { WindowUtils as no } from "../util/window-utils.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as p } from "../common/constants.js";
import { SupportedOptions as zt, logger as N } from "../../shared-lib/index.js";
import _t from "../models/identifier.js";
var z = {
  Oo: "allowCrawlerActivity",
  Ro: "baseUrl",
  Lo: "noCookies",
  Wo: "devicePropertyAllowlist",
  Da: "disablePushTokenMaintenance",
  Vo: "enableLogging",
  Ko: "enableSdkAuthentication",
  Ca: "manageServiceWorkerExternally",
  Go: "minimumIntervalBetweenTriggerActionsInSeconds",
  Yo: "sessionTimeoutInSeconds",
  Ho: "appVersion",
  Xo: "appVersionNumber",
  _a: "serviceWorkerLocation",
  Ba: "safariWebsitePushId",
  Ea: "localization",
  ir: "contentSecurityNonce",
  er: "allowUserSuppliedJavascript",
  Jo: "inAppMessageZIndex",
  Do: "openInAppMessagesInNewTab",
  tn: "openCardsInNewTab",
  en: "openNewsFeedCardsInNewTab",
  mh: "requireExplicitInAppMessageDismissal",
  Zo: "doNotLoadFontAwesome",
  Qo: "deviceId",
  Aa: "serviceWorkerScope",
  Wh: "sdkFlavor"
};

var Vt = /*#__PURE__*/function () {
  function Vt() {
    _classCallCheck(this, Vt);

    this.yn = "", this.Vh = "", this.$h = void 0, this.Yh = null, this.wn = null, this.S = null, this.Ue = null, this.B = null, this.T = null, this.C = null, this.As = null, this.Xh = "", this.isInitialized = !1, this.Zh = !1, this.Qh = new u(), this.Ia = new u(), this.options = {}, this.Na = [], this.Oa = [], this.Ir = [], this.Vh = "5.6.0";
  }

  _createClass(Vt, [{
    key: "Ta",
    value: function Ta(t) {
      this.Qh.Ns(t);
    }
  }, {
    key: "Nh",
    value: function Nh(t) {
      this.Ia.Ns(t);
    }
  }, {
    key: "initialize",
    value: function initialize(i, s) {
      var _this = this;

      if (this.nt()) return N.info("Braze has already been initialized with an API key."), !0;
      this.options = s || {};
      var e = this.sr(z.Vo);
      var r = ll(no.Ra());
      if (r && "true" === r.brazeLogging && (e = !0), N.init(e), N.info("Initialization Options: ".concat(JSON.stringify(this.options, null, 2))), null == i || "" === i || "string" != typeof i) return N.error("Braze requires a valid API key to be initialized."), !1;
      this.yn = i;
      var n = this.sr(z.Ro);
      if (null == n || "" === n || "string" != typeof n) return N.error("Braze requires a valid baseUrl to be initialized."), !1;
      !1 === /^https?:/.test(n) && (n = "https://".concat(n));
      var o = n;
      if (n = document.createElement("a"), n.href = o, "/" === n.pathname && (n = "".concat(n, "api/v3")), this.Xh = n.toString(), ro.Pa && !this.sr(z.Oo)) return N.info("Ignoring activity from crawler bot " + navigator.userAgent), this.Zh = !0, !1;
      var h = this.sr(z.Lo) || !1;
      if (this.C = Wt.La(i, h), h && this.C.Ua(i), new ne.ne(null, !0).gr(t.ae)) return N.info("Ignoring all activity due to previous opt out"), this.Zh = !0, !1;

      var _iterator = _createForOfIteratorHelper(y(this.options)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t4 = _step.value;
          -1 === Rt(zt).indexOf(_t4) && N.warn("Ignoring unknown initialization option '".concat(_t4, "'."));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var a = ["mparticle", "wordpress", "tealium"];

      if (null != this.sr(z.Wh)) {
        var _t2 = this.sr(z.Wh);

        -1 !== a.indexOf(_t2) ? this.$h = _t2 : N.error("Invalid sdk flavor passed: " + _t2);
      }

      var l = this.sr(zt.Wo);
      if (null != l) if (w(l)) {
        var _t3 = [];

        for (var _i = 0; _i < l.length; _i++) {
          ta(DeviceProperties, l[_i], "devicePropertyAllowlist contained an invalid value.", "DeviceProperties") && _t3.push(l[_i]);
        }

        l = _t3;
      } else N.error("devicePropertyAllowlist must be an array. Defaulting to all properties."), l = null;
      var c = this.sr(z.Qo);

      if (c) {
        var _i2 = new _t(c);

        this.C.uu(t.iu.Qo, _i2);
      }

      this.wn = new Ot(this.C, l), this.B = new Dt(this.C), this.As = new kt(this.B, this.C), this.T = new Mt(this.C, this.As, this.B, this.sr(z.Yo));
      var f = new u();
      return this.Yh = new qt(this.C, this.sr(z.Ko), f), this.N(f), this.S = new Pt(this.wn, this.C, this.Yh, this.As, this.T, this.B, this.yn, this.Xh, this.Vh, this.$h || "", this.sr(z.Ho), this.sr(z.Xo)), this.Ue = new Lt(this.yn, this.Xh, this.T, this.wn, this.As, this.B, this.C, function (t) {
        if (_this.nt()) {
          var _iterator2 = _createForOfIteratorHelper(_this.lr()),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _i3 = _step2.value;

              _i3.U(t);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }, this.Yh, this.S), this.Ue.initialize(), h || this.C.Wa(), N.info("Initialized for the Braze backend at \"".concat(this.sr(z.Ro), "\" with API key \"").concat(this.yn, "\".")), ot.p(), this.B.Re(function () {
        var t;
        _this.isInitialized && (null === (t = _this.B) || void 0 === t ? void 0 : t.Qi()) && import("../FeatureFlags/refresh-feature-flags.js").then(function (t) {
          if (!_this.isInitialized) return;
          (0, t["default"])();
        });
      }), this.Ue.rn(function () {
        var t;
        _this.isInitialized && (null === (t = _this.B) || void 0 === t ? void 0 : t.Qi()) && import("../FeatureFlags/refresh-feature-flags.js").then(function (t) {
          if (!_this.isInitialized) return;
          (0, t["default"])(void 0, void 0, !0);
        });
      }), this.Qh.X(this.options), this.isInitialized = !0, window.dispatchEvent(new CustomEvent("braze.initialized")), !0;
    }
  }, {
    key: "destroy",
    value: function destroy(t) {
      if (N.destroy(), this.nt()) {
        this.Ia.X(), this.Ia.removeAllSubscriptions();

        var _iterator3 = _createForOfIteratorHelper(this.Na),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _t5 = _step3.value;

            _t5.destroy();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        this.Na = [];

        var _iterator4 = _createForOfIteratorHelper(this.Oa),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _t6 = _step4.value;

            _t6.clearData(!1);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this.Oa = [], this.removeAllSubscriptions(), this.Ir = [], null != this.Ue && this.Ue.destroy(), this.Ue = null, this.Yh = null, this.wn = null, this.S = null, this.B = null, this.T = null, this.As = null, this.options = {}, this.$h = void 0, this.isInitialized = !1, this.Zh = !1, t && (this.C = null);
      }
    }
  }, {
    key: "rr",
    value: function rr() {
      return !this.Va() && (!!this.nt() || (console.warn(p), !1));
    }
  }, {
    key: "Ma",
    value: function Ma() {
      return this.yn;
    }
  }, {
    key: "Sr",
    value: function Sr() {
      return this.Yh;
    }
  }, {
    key: "Z",
    value: function Z() {
      return this.Xh;
    }
  }, {
    key: "te",
    value: function te() {
      return this.wn;
    }
  }, {
    key: "g",
    value: function g() {
      return this.S;
    }
  }, {
    key: "sr",
    value: function sr(t) {
      return this.options[t];
    }
  }, {
    key: "lr",
    value: function lr() {
      return this.Oa;
    }
  }, {
    key: "nn",
    value: function nn() {
      return this.Ue;
    }
  }, {
    key: "v",
    value: function v() {
      return this.B;
    }
  }, {
    key: "P",
    value: function P() {
      return this.T;
    }
  }, {
    key: "j",
    value: function j() {
      return this.C;
    }
  }, {
    key: "cr",
    value: function cr() {
      if (this.As && this.Ue) return new User(this.As, this.Ue);
    }
  }, {
    key: "tr",
    value: function tr() {
      return this.As;
    }
  }, {
    key: "nr",
    value: function nr() {
      return !0 === this.sr(z.er);
    }
  }, {
    key: "h",
    value: function h(t) {
      var i = !1;

      var _iterator5 = _createForOfIteratorHelper(this.Na),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _s = _step5.value;
          _s === t && (i = !0);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      i || this.Na.push(t);
    }
  }, {
    key: "_",
    value: function _(t) {
      var i = !1;

      var _iterator6 = _createForOfIteratorHelper(this.Oa),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _s2 = _step6.value;
          _s2.constructor === t.constructor && (i = !0);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      t instanceof s && !i && this.Oa.push(t);
    }
  }, {
    key: "N",
    value: function N(t) {
      t instanceof u && this.Ir.push(t);
    }
  }, {
    key: "removeAllSubscriptions",
    value: function removeAllSubscriptions() {
      if (this.rr()) {
        var _iterator7 = _createForOfIteratorHelper(this.Ir),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _t7 = _step7.value;

            _t7.removeAllSubscriptions();
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(t) {
      if (this.rr()) {
        var _iterator8 = _createForOfIteratorHelper(this.Ir),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var i = _step8.value;
            i.removeSubscription(t);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
    }
  }, {
    key: "re",
    value: function re(t) {
      this.Zh = t;
    }
  }, {
    key: "nt",
    value: function nt() {
      return this.isInitialized;
    }
  }, {
    key: "Va",
    value: function Va() {
      return this.Zh;
    }
  }, {
    key: "Ui",
    value: function Ui() {
      return this.Vh;
    }
  }]);

  return Vt;
}();

var r = new Vt();
export { r as default, Vt as BrazeSdkInstance, z as OPTIONS };